/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CourtTypesService {
    /**
     * List all court types
     * Get a paginated list of court types for the authenticated user
     * @param isActive Filter by active status
     * @param search Search by court type name
     * @returns any List of court types
     * @throws ApiError
     */
    public static cf59D5654A1Afd1E2B1Ac(
        isActive?: 'Yes' | 'No',
        search?: string,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/court-types',
            query: {
                'is_active': isActive,
                'search': search,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new court type
     * Create a new court type
     * @param requestBody
     * @returns any Court type created successfully
     * @throws ApiError
     */
    public static c6C7B735Bc6Bae01F48429F514551(
        requestBody: {
            court_type_name: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/court-types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific court type
     * Retrieve details of a specific court type
     * @param id Court type ID
     * @returns any Court type details
     * @throws ApiError
     */
    public static a6B922874716097Ae7Cf2E57Ef73D303(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/court-types/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Court type not found`,
            },
        });
    }
    /**
     * Update a court type
     * Update an existing court type
     * @param id Court type ID
     * @param requestBody
     * @returns any Court type updated successfully
     * @throws ApiError
     */
    public static fd1049203428Dad909A31D347869F0Ed(
        id: number,
        requestBody: {
            court_type_name?: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/court-types/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Court type not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete a court type
     * Delete a court type
     * @param id Court type ID
     * @returns any Court type deleted successfully
     * @throws ApiError
     */
    public static a3443Fcf56Df8E40C51E498293E4B632(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/court-types/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Court type not found`,
            },
        });
    }
}
